import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if(environment.sentryEnabled){
  Sentry.init({
    dsn: environment.sentryDSN,
    environment: environment.production ? "production" : "development",
    release: "trade-client@" + environment.sentryRelease,
    attachStacktrace: true,
    sendDefaultPii: true,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => {
  if (environment.sentryEnabled) {
    Sentry.captureException(err);
  } else {
    console.error(err);
  }
});
